var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShips(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7351 21.6474C37.2576 22.2599 38.2026 24.0625 37.8526 25.655L37.135 28.9099C35.8925 34.5099 31.5001 38.4999 25.1651 38.4999H16.835C10.5 38.4999 6.10754 34.5099 4.86504 28.9099L4.14753 25.655C3.79753 24.0625 4.74252 22.2599 6.26502 21.6474L8.75004 20.6499L18.3926 16.7824C20.0726 16.1174 21.9275 16.1174 23.6075 16.7824L33.25 20.6499L35.7351 21.6474Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 38.5V17.5",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 14V20.65L23.6075 16.7825C21.9275 16.1175 20.0725 16.1175 18.3925 16.7825L8.75 20.65V14C8.75 11.1125 11.1125 8.75 14 8.75H28C30.8875 8.75 33.25 11.1125 33.25 14Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.375 8.75H16.625V5.25C16.625 4.2875 17.4125 3.5 18.375 3.5H23.625C24.5875 3.5 25.375 4.2875 25.375 5.25V8.75Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShips);
export default __webpack_public_path__ + "static/media/ships.510cab121f0f64e70ac62d06c1eeb37c.svg";
export { ForwardRef as ReactComponent };